import { isStorageAvailable } from '$helpers/storage';

export default class LocalStorageWrapper {
    private static instance: LocalStorageWrapper;

    private storage: Storage | null;

    private constructor() {
        if (isStorageAvailable('localStorage')) {
            this.storage = window.localStorage;
        } else {
            console.warn('LocalStorage is not available.');
            this.storage = null;
        }
    }

    public static getItem(key: string): string | null {
        const storage = this.getStorage();
        return storage ? storage.getItem(key) : null;
    }

    public static setItem(key: string, value: string): void {
        const storage = this.getStorage();
        if (storage) {
            storage.setItem(key, value);
        }
    }

    public static removeItem(key: string): void {
        const storage = this.getStorage();
        if (storage) {
            storage.removeItem(key);
        }
    }

    private static getStorage(): Storage | null {
        if (!this.instance) {
            this.instance = new LocalStorageWrapper();
        }
        return this.instance.storage;
    }
}
